import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk";
import { createLogger } from "redux-logger";
import rootReducer from "./rootReducer";

import {
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";

// Config for redux-persist
const persistConfig = {
  key: "root",
  storage,
};

// Combine persist with root reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Logger (only used in development mode)
const logger = createLogger({
  collapsed: true,
  predicate: () => process.env.NODE_ENV !== "production",
});

// Create store
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(thunk, logger),
  devTools: process.env.NODE_ENV !== "production",
});

// Setup persistor
const persistor = persistStore(store);

export { store, persistor };
